import { Translator, Button } from '@itarget/shared'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Icon,
} from '@material-ui/core'
import { useStyles } from './styles'
import { useTranslation } from './translation'

const Modal = ({
  open,
  image,
  title,
  className,
  definition,
  description,
  handleClose,
  handleDecline,
  handleAgree,
}) => {
  const styles = useStyles()
  const translation = useTranslation()

  const onClickClose = () => {
    handleClose()
  }

  const onClickDecline = () => {
    handleClose()
    handleDecline()
  }

  const onClickAgree = () => {
    handleClose()
    handleAgree(true)
  }

  return (
    <Dialog
      open={open}
      maxWidth="md"
      onClose={onClickClose}
      className={`${styles.container} ${className}`}
    >
      <DialogTitle className={`${styles.title} ${styles.text}`}>
        <Translator transRef={`translation.${title}`} />
        <Icon onClick={onClickClose} className={styles.closeIcon}>
          close
        </Icon>
      </DialogTitle>
      <DialogContent>
        {definition && (
          <DialogContentText className={`${styles.definition} ${styles.text}`}>
            <div dangerouslySetInnerHTML={{ __html: definition }} />
          </DialogContentText>
        )}
        {image && (
          <Box className={styles.imageContainer}>
            <img alt={title} src={image} />
          </Box>
        )}
        <DialogContentText className={styles.text}>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions className={styles.actionsContainer}>
        {handleAgree && (
          <Button
            onClick={onClickAgree}
            className={`${styles.actions} ${styles.actionAgree} actionAgree`}
          >
            <Translator transRef={'translation.Aceitar e continuar'} />
          </Button>
        )}
        {handleDecline && (
          <Button
            variant="outlined"
            onClick={onClickDecline}
            className={`${styles.actions} ${styles.actionDecline} actionDecline`}
          >
            <Translator transRef={'translation.Recusar'} />
          </Button>
        )}
        {!handleDecline && (
          <Button
            variant="outlined"
            onClick={onClickClose}
            className={`${styles.actions} ${styles.actionClose} actionClose`}
          >
            <Translator transRef={'translation.Fechar'} />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default Modal
